import React, { Component } from 'react'
import ReactGA              from 'react-ga'
import ReactDOM             from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch,
  withRouter,
} from 'react-router-dom'

import Data           from './data'
import Meta           from './components/meta'
import FirstPage      from './first-page'
import Gallery        from './gallery'
import Image          from './image'
import Archive        from './archive'
import Document       from './document'
import { formatHTML } from './components/format'

import './css/index.css'

class App extends Component {

  state = {}

  componentDidMount() {
    this.setLanguage(localStorage.language)
  }

  setLanguage(language) {
    if (localStorage[language]) {
      this.setData(localStorage[language])
    } else {
      this.setState({data: null})
    }
    let dataURL = document.getElementById('root').getAttribute('data-url')
    let headers = new Headers(language ? {'Accept-Language': language} : {})
    if (this.promise) {
      this.promise.cancelled = true
      this.promise = undefined
    }
    let promise = fetch(dataURL, { headers })
      .then(data => data.json())
      .then(data => {
        if (promise.cancelled) {
          return
        }
        this.setData(data)
      })
    this.promise = promise
  }

  setData(data) {
    if (typeof data === 'string') {
      data = JSON.parse(data)
    }
    if (this.google_analytics !== data.content.google_analytics) {
      this.google_analytics = data.content.google_analytics
      ReactGA.initialize(this.google_analytics)
    }
    localStorage.language = data.language
    localStorage[data.language] = JSON.stringify(data)
    if (this.state.data) {
      data.design = this.state.data.design
    }
    this.setState({data: new Data(data)}, () => {
        formatHTML.parseURL = this.state.data.parseURL.bind(this.state.data)
    })
  }

  render() {
    if (!this.state.data) {
      return <Loading />
    }
    let colorClass = 'container-' + this.state.data.design.color
    ReactGA.pageview(this.state.data.language + '/' + window.location.pathname + window.location.search)
    return (
      <Router>
        <div className={`container ${colorClass}`}>
          <Meta data={this.state.data} />
          <Mascot data={this.state.data} />
          <Banner
            data        = {this.state.data}
            setLanguage = {this.setLanguage.bind(this)} />
          <Menu data={this.state.data} />
          <div id="main">
            <Switch>
              <Route exact={true} path={this.state.data.urls.index} render={({ match }) => (
                <FirstPage data={this.state.data} />
              )} />
              {this.state.data.gallery_sections.map(section => (
                <Route key={section.key} exact={true} path={section.gallery_url} render={({ match }) => {
                  let series = match.params.series ? section.getItem(match.params.series) : section
                  if (!series) {
                    return <NoMatch data={this.state.data} section={section} />
                  }
                  return <Gallery data={this.state.data} section={series} />
                }} />
              ))}
              {this.state.data.catalog_sections.map(section => (
                <Route key={section.key} exact={true} path={section.catalog_url} render={({ match }) => (
                  <Archive data={this.state.data} catalog={section} />
                )} />
              ))}
              {this.state.data.image_sections.map(section => (
                <Route key={section.key} exact={true} path={section.image_url} render={({ match }) => {
                  let item = section.getItem(match.params.item)
                  if (!item) {
                    return <NoMatch data={this.state.data} section={section} />
                  }
                  return <Image data={this.state.data} item={item} />
                }} />
              ))}
              {this.state.data.photo_sections.map(section => (
                <Route key={section.key} exact={true} path={section.photo_url} render={({ match }) => {
                  let item = section.getItem(match.params.item)
                  if (!item) {
                    return <NoMatch data={this.state.data} section={section} />
                  }
                  return <Gallery data={this.state.data} section={section} item={item} />
                }} />
              ))}
              {this.state.data.archive_sections.map(section => (
                <Route key={section.key} exact={true} path={section.archive_url} render={({ match }) => (
                  <Archive data={this.state.data} section={section} />
                )} />
              ))}
              {this.state.data.document_sections.map(section => (
                <Route key={section.key} path={section.document_url} render={({ match }) => {
                  let item = section.getItem(match.params.item)
                  if (!item) {
                    return <NoMatch data={this.state.data} section={section} />
                  }
                  return <Document data={this.state.data} item={item} />
                }} />
              ))}
              {this.state.data.pages.map(page => (
                <Route key={page.key} exact={true} path={page.url} render={({ match }) => (
                  <Document data={this.state.data} item={page} />
                )} />
              ))}
              <Route render={({ match }) => (
                <NoMatch data={this.state.data} />
              )} />
            </Switch>
          </div>
          <div id="footer" />
        </div>
      </Router>
    )
  }

}

function Loading(props) {
  return (
    <div className="loading" />
  )
}

function Mascot(props) {
  return (
    <div className="mascot" style={{backgroundImage: `url(${props.data.design.mascot})`}} />
  )
}

class Banner extends Component {

  click(e) {
    if (e.target.tagName === 'HEADER') {
      this.props.history.push(this.props.data.urls.index)
    }
  }

  render() {
    return (
      <header onClick={this.click.bind(this)} className="banner" style={{backgroundImage: `url(${this.props.data.design.banner})`}}>
        <a href={`mailto:${this.props.data.content.email}`} className="banner-email" title={this.props.data.content.email_hint}>{this.props.data.content.email}</a>
        <div className="banner-languages">
          <div
            onClick   = {() => this.props.setLanguage('ru')}
            className = {'banner-language' + (this.props.data.language === 'ru' ? ' banner-language-selected' : '')}
          >{this.props.data.content.language_ru}</div>
          <div
            onClick   = {() => this.props.setLanguage('en')}
            className = {'banner-language' + (this.props.data.language === 'en' ? ' banner-language-selected' : '')}
          >{this.props.data.content.language_en}</div>
          <div
            onClick   = {() => this.props.setLanguage('uk')}
            className = {'banner-language' + (this.props.data.language === 'uk' ? ' banner-language-selected' : '')}
          >{this.props.data.content.language_uk}</div>
        </div>
      </header>
    )
  }

}

Banner = withRouter(Banner)

class Menu extends Component {

  state = {gallery: false, materials: false}

  componentDidMount() {
    window.addEventListener('click', this.toggleMenu.bind(this))
  }

  toggleMenu(e, section) {
    e.stopPropagation()
    let state = {gallery: false, materials: false}
    if (section === 'gallery') {
      state.gallery = !this.state.gallery
    }
    if (section === 'materials') {
      state.materials = !this.state.materials
    }
    this.setState(state)
  }

  render() {
    return (
      <nav className="menu">
        <div className="menu-section" onClick={e => this.toggleMenu(e, 'gallery') }>
          <div className="menu-section-text link">{this.props.data.content.menu_gallery}</div>
          <div className="menu-options" style={{display: this.state.gallery ? 'block' : 'none'}}>
            <Link to={this.props.data.printed_graphics.gallery_url} className="menu-option">{this.props.data.printed_graphics.title}</Link>
            <Link to={this.props.data.color_graphics.gallery_url} className="menu-option">{this.props.data.color_graphics.title}</Link>
            <Link to={this.props.data.paintings.gallery_url} className="menu-option">{this.props.data.paintings.title}</Link>
            <Link to={this.props.data.sketches.gallery_url} className="menu-option">{this.props.data.sketches.title}</Link>
          </div>
        </div>
        <div className="menu-section" onClick={e => this.toggleMenu(e, 'materials') }>
          <div className="menu-section-text link">{this.props.data.content.menu_materials}</div>
          <div className="menu-options" style={{display: this.state.materials ? 'block' : 'none'}}>
            <Link to={this.props.data.news.archive_url} className="menu-option">{this.props.data.news.title}</Link>
            <Link to={this.props.data.exhibitions.archive_url} className="menu-option">{this.props.data.exhibitions.title}</Link>
            <Link to={this.props.data.photos.gallery_url} className="menu-option">{this.props.data.photos.title}</Link>
            <Link to={this.props.data.autobiography.url} className="menu-option">{this.props.data.autobiography.title}</Link>
            <Link to={this.props.data.biography.url} className="menu-option">{this.props.data.biography.title}</Link>
            <Link to={this.props.data.texts_by_aksinin.archive_url} className="menu-option">{this.props.data.texts_by_aksinin.title}</Link>
            <Link to={this.props.data.articles_about_aksinin.archive_url} className="menu-option">{this.props.data.articles_about_aksinin.title}</Link>
            <Link to={this.props.data.printed_graphics.catalog_url} className="menu-option">{this.props.data.printed_graphics.catalog_title}</Link>
            <Link to={this.props.data.color_graphics.catalog_url} className="menu-option">{this.props.data.color_graphics.catalog_title}</Link>
            <Link to={this.props.data.paintings.catalog_url} className="menu-option">{this.props.data.paintings.catalog_title}</Link>
            <Link to={this.props.data.bibliography.archive_url} className="menu-option">{this.props.data.bibliography.title}</Link>
          </div>
        </div>
        <div className="menu-section">
          <Link to={this.props.data.art_milieu.archive_url} className="menu-section-text">{this.props.data.art_milieu.title}</Link>
        </div>
      </nav>
    )
  }

}

function NoMatch(props) {
  return (
    <div className="not-found">
      {props.data.content.not_found_hint}
      {props.section && props.section.url && (
        <Link to={props.section.url} className="not-found-link">{props.data.content.not_found_link_hint}</Link>
      )}
    </div>
  )
}

ReactDOM.render(<App />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js